module.exports = __webpack_public_path__ + "img/community_building.c3f9415f.png";